import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconLink = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5 11.6364C5 10.1803 6.18034 9 7.63636 9H9.81818C10.3705 9 10.8182 8.55228 10.8182 8C10.8182 7.44772 10.3705 7 9.81818 7H7.63636C5.07577 7 3 9.07577 3 11.6364C3 12.866 3.48847 14.0453 4.35796 14.9148C5.22745 15.7843 6.40672 16.2727 7.63636 16.2727H9.81818C10.3705 16.2727 10.8182 15.825 10.8182 15.2727C10.8182 14.7204 10.3705 14.2727 9.81818 14.2727H7.63636C6.93716 14.2727 6.26659 13.995 5.77217 13.5006C5.27776 13.0061 5 12.3356 5 11.6364ZM14.1818 7C13.6295 7 13.1818 7.44772 13.1818 8C13.1818 8.55228 13.6295 9 14.1818 9H16.3636C17.0628 9 17.7334 9.27776 18.2278 9.77217C18.7222 10.2666 19 10.9372 19 11.6364C19 13.0924 17.8197 14.2727 16.3636 14.2727H14.1818C13.6295 14.2727 13.1818 14.7204 13.1818 15.2727C13.1818 15.825 13.6295 16.2727 14.1818 16.2727H16.3636C18.9242 16.2727 21 14.197 21 11.6364C21 10.4067 20.5115 9.22745 19.642 8.35796C18.7726 7.48847 17.5933 7 16.3636 7H14.1818ZM9.09082 10.6364C8.53854 10.6364 8.09082 11.0841 8.09082 11.6364C8.09082 12.1886 8.53854 12.6364 9.09082 12.6364H14.909C15.4613 12.6364 15.909 12.1886 15.909 11.6364C15.909 11.0841 15.4613 10.6364 14.909 10.6364H9.09082Z"
        />
      </svg>
    );
  }
);
